import React from 'react';

class Todo extends React.Component {
  render() {
    return <div>This feature is not yet implemented</div>;
  }
}

export default Todo;



// WEBPACK FOOTER //
// ./src/components/common/todo/Todo.js